import { readMaintenanceConfig, renderMaintenance } from './maintenance.js';

async function bootstrap(): Promise<void> {
  const maintenance = await readMaintenanceConfig();
  if (maintenance.enabled) {
    await import('./styles/maintenance.css');
    renderMaintenance(maintenance);
    return;
  }

  const [{ default: React }, { default: ReactDOM }, { App }] = await Promise.all([
    import('react'),
    import('react-dom/client'),
    import('./App.js'),
    import('./styles/index.css'),
  ]);
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element #root not found');
  ReactDOM.createRoot(root).render(React.createElement(React.StrictMode, null, React.createElement(App)));
}

void bootstrap();
